export default {
    methods: {
        formatMimeType(mime) {
          const mimeTypes = {
            "application/json": "JSON",
            "application/javascript": "JavaScript",
            "application/pdf": "PDF",
            "application/xml": "XML",
            "application/zip": "ZIP Archive",
            "application/vnd.ms-excel": "Excel",
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": "Excel (XLSX)",
            "application/vnd.ms-powerpoint": "PowerPoint",
            "application/vnd.openxmlformats-officedocument.presentationml.presentation": "PowerPoint (PPTX)",
            "application/msword": "Word",
            "application/vnd.openxmlformats-officedocument.wordprocessingml.document": "Word (DOCX)",
            "audio/mpeg": "MP3 Audio",
            "audio/ogg": "OGG Audio",
            "audio/wav": "WAV Audio",
            "image/jpeg": "JPEG Image",
            "image/png": "PNG Image",
            "image/gif": "GIF Image",
            "image/svg+xml": "SVG Image",
            "image/webp": "WebP Image",
            "text/css": "CSS",
            "text/html": "HTML",
            "text/javascript": "JavaScript",
            "text/plain": "Plain Text",
            "text/xml": "XML",
            "video/mp4": "MP4 Video",
            "video/webm": "WebM Video",
            "video/ogg": "OGG Video",
            "video/quicktime": "QuickTime Video",
          };
          return mimeTypes[mime] || mime;
        },
      formatSize(bytes) {
        const k = 1024;
        const dm = 2;
        const sizes = this.$primevue.config.locale.fileSizeTypes;

        if (bytes === 0) {
          return `0 ${sizes[0]}`;
        }

        const i = Math.floor(Math.log(bytes) / Math.log(k));
        const formattedSize = parseFloat((bytes / Math.pow(k, i)).toFixed(dm));

        return `${formattedSize} ${sizes[i]}`;
      }
    }
}
